import React from 'react';
import { PurchaseRequestForm } from '../components/PurchaseRequestForm';

export const NewRequestPage: React.FC = () => {
  return <PurchaseRequestForm mode="CREATE" defaultProcurementType="Material" />;
};
